var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"container"},'div',_vm.$attrs,false),_vm.$listeners),[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/image/button/add.svg")}}),_vm._v(_vm._s(_vm.Text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }